import { Store } from "../lib";
import { PickupOption } from "../models";

export default class PickupOptionsStore extends Store {
  model = PickupOption;
  baseWebURI = "/app/pickup_zones/list";
}
